var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { useStore } from "effector-react";
import { Box, IconButton, Slider } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { VolumeDown, VolumeOff, VolumeUp } from "@material-ui/icons";
import { $audioVolume } from "frontend/src/domain/audio";
import { audioVolumeChanged } from "frontend/src/features/change-audio-volume";
var useStyles = makeStyles(function (theme) {
    var _a;
    return ({
        box: (_a = {},
            _a[theme.breakpoints.up("sm")] = {
                width: 175,
            },
            _a),
    });
});
export var Volume = function () {
    var volume = useStore($audioVolume);
    var _a = __read(React.useState(volume * 100), 2), sliderValue = _a[0], setSliderValue = _a[1];
    var _b = __read(React.useState(false), 2), isChanging = _b[0], setChanging = _b[1];
    var _c = __read(React.useState(0.5), 2), nonZeroVolume = _c[0], setNonZeroVolume = _c[1];
    var classes = useStyles();
    var VolumeIcon = React.useMemo(function () {
        if (volume === 0) {
            return VolumeOff;
        }
        if (volume < 0.5) {
            return VolumeDown;
        }
        return VolumeUp;
    }, [volume]);
    var onVolumeToggle = function () {
        if (volume !== 0) {
            setNonZeroVolume(volume);
            audioVolumeChanged(0);
        }
        else {
            audioVolumeChanged(nonZeroVolume);
        }
    };
    var onSliderValueChange = function (e, value) {
        if (typeof value === "number") {
            setChanging(true);
            setSliderValue(value);
            audioVolumeChanged(value / 100);
        }
    };
    var onChangeCommitted = function () {
        setChanging(false);
    };
    React.useEffect(function () {
        if (!isChanging) {
            setSliderValue(volume * 100);
        }
    }, [volume, isChanging]);
    return (React.createElement(Box, { display: "flex", alignItems: "center", className: classes.box },
        React.createElement(Box, { mr: 2, display: "flex" },
            React.createElement(IconButton, { onClick: onVolumeToggle, size: "small" },
                React.createElement(VolumeIcon, { htmlColor: "black" }))),
        React.createElement(Slider, { value: sliderValue, onChange: onSliderValueChange, onChangeCommitted: onChangeCommitted })));
};
